// extracted by mini-css-extract-plugin
module.exports = {"newsArticle":"styles_newsArticle__VaqWq","pageContent":"styles_pageContent__D6nXU"};